import { TeamMember } from '@/types';

export const team: TeamMember[] = [
  {
    hash: `b42e5a6c8fa64953d9760dc485b8ba1a`,
    name: `Sean Callahan`,
    title: `Founder`,
    bio: `Sean is a technology executive, and has overseen the development of healthcare, and finance platforms.`,
    avatar: `/img/avatars/seanc.webp`,
    email: `sean@pentester.com`,
    // linkedin: `#`,
    // twitter: `osean_man`,
  },
  {
    hash: `e832f20c1755f954132f425b630a9583`,
    name: `Rick Glaser`,
    title: `Founder`,
    bio: `Rick is an administrator with over 10 years experience working in healthcare and building SaaS companies. `,
    avatar: `/img/avatars/rick.webp`,
    email: `rick@pentester.com`,
    linkedin: `rick-glaser-a532b1b/`,
    // twitter: `rickglaser_`,
  },
  {
    hash: `661b9f72764311db354588945cea1b4b`,
    name: `Fawaz Adi`,
    title: `Sr. Red Team`,
    bio: `Fawaz is a full-stack developer, information security analyst and penetration tester.`,
    avatar: `/img/avatars/fawaz.webp`,
    email: `fawaz@pentester.com`,
    // linkedin: `#`,
    twitter: `q8fawazo`,
  },
  {
    hash: `ffc365fa040f726f9f993e970dcaa442`,
    name: `Dimitar Marinov`,
    title: `CTO`,
    bio: `Dimitar leads the development of Pentester, and has vast data science, AI, and machine learning experience.`,
    avatar: `/img/avatars/dimitar.webp`,
    email: `dimitar@pentester.com`,
    linkedin: `dmar5/`,
    // twitter: `#`,
  },
];
